import {
  watchLoadSingleSitesList,
  watchLoadSingleSitesListRefresh,
  watchLoadSingleSiteView,
  watchLoadSingleSiteContacts,
  watchSingleSiteAddContact,
  watchSingleSiteUpdateContact,
  watchSingleSiteRemoveContact,
  watchSingleSiteMoveContact,
  watchLoadSingleSiteNotificationsRules,
  watchSingleSiteNotificationsAddRule,
  watchSingleSiteNotificationsRemoveRule,
  watchLoadSingleSiteNotificationHistory,
  watchLoadSiteSchedules,
  watchLoadSingleSiteUsers,
  watchSingleSiteUserGrantAccess,
  watchSingleSiteUserRemove,
} from "./singleSites";

import { all } from "redux-saga/effects";

export function* rootSaga() {
  yield all(
    [
      watchLoadSingleSitesList(),
      watchLoadSingleSitesListRefresh(),
      watchLoadSingleSiteView(),
      watchLoadSingleSiteContacts(),
      watchSingleSiteAddContact(),
      watchSingleSiteUpdateContact(),
      watchSingleSiteRemoveContact(),
      watchSingleSiteMoveContact(),
      watchLoadSingleSiteNotificationsRules(),
      watchSingleSiteNotificationsAddRule(),
      watchSingleSiteNotificationsRemoveRule(),
      watchLoadSingleSiteNotificationHistory(),
      watchLoadSiteSchedules(),
      watchLoadSingleSiteUsers(),
      watchSingleSiteUserGrantAccess(),
      watchSingleSiteUserRemove(),
    ],
  );
}